module.exports = __webpack_public_path__ + "img/Group@3x.c73776d4.svg";